import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Css, Responsive } from '@/ui';
import { Color } from '../../../../styles/Color';
import { RouterLink } from '../../link/RouterLink';

export const Label = styled.span`
	transition: opacity 0.3s;
	font-weight: 400;
`;

export const navItemStyles = css`
	height: ${Css.pxToRem(40)};
	padding: 0 ${Css.pxToRem(16)};
	border-radius: 9999px;
	display: flex;
	gap: ${Css.pxToRem(8)};
	align-items: center;
	overflow: hidden;
	justify-content: flex-start;
	max-width: var(--link-width);
	color: ${Color.OnBackgroundText};
	text-decoration: none;
	transition: max-width 0.35s cubic-bezier(0.65, 0, 0.35, 1);
	width: 100%;
	white-space: nowrap;
	border: none;
	background: transparent;

	& svg {
		width: ${Css.pxToRem(24)};
		height: ${Css.pxToRem(24)};
		flex-shrink: 0;

		path {
			fill: currentColor;
		}
	}

	&:active {
		background: ${Color.Neutral94};
		color: ${Color.SecondaryBlue1};
	}

	&[data-state='collapsed']:not(:hover) {
		max-width: ${Css.pxToRem(56)};

		${Label} {
			opacity: 0;
		}
	}

	&[aria-current='page'],
	&[aria-current='true'] {
		background: ${Color.PrimaryBlue97};
		color: ${Color.PrimaryBlue};
	}

	&:not([aria-current='page']):not([aria-current='true']):hover {
		text-decoration: underline;
		color: ${Color.OnBackgroundText};

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			text-decoration: none;
		}
	}
`;

export const StyledLink = styled(RouterLink)`
	${navItemStyles}
`;

export const StyledButton = styled.button`
	${navItemStyles}
`;
